import { useId } from 'react';

/**
 * TrashAnimatedIcon — Ícone de lixeira animado padrão do Joshua.
 *
 * Uso: envolva com um elemento que tenha a classe `gf-trash-animated`
 * para ativar a animação no hover (tampa voa, corpo balança, linhas tremem).
 *
 * Exemplo:
 *   <button className="btn-delete-icon gf-trash-animated" onClick={onDelete}>
 *     <TrashAnimatedIcon size={18} />
 *   </button>
 */
export default function TrashAnimatedIcon({ size = 18 }) {
  const id = useId();
  const gid = `trashG${id}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <defs>
        <linearGradient id={gid} gradientUnits="userSpaceOnUse" x1="3" y1="0" x2="21" y2="0">
          <stop offset="0%" stopColor="#f87171" />
          <stop offset="100%" stopColor="#7f1d1d" />
        </linearGradient>
      </defs>
      <g className="trash-lid" stroke={`url(#${gid})`}>
        <path d="M3 6h18" />
        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
      </g>
      <g className="trash-body" stroke={`url(#${gid})`}>
        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
      </g>
      <g className="trash-lines" stroke={`url(#${gid})`}>
        <line x1="10" x2="10" y1="11" y2="17" />
        <line x1="14" x2="14" y1="11" y2="17" />
      </g>
    </svg>
  );
}
